/* PerlPanther – Reveal beim Scrollen.
   Setzt .tw-js sofort (damit der versteckte Zustand ueberhaupt erst greift)
   und blendet .tw-reveal-Elemente ein, sobald sie in den Viewport kommen.
   Beobachtet auch spaeter eingefuegte Sections, damit es im Theme-Editor
   nach einem Section-Re-Render weiter funktioniert. */
(function () {
  var root = document.documentElement;
  root.classList.add('tw-js');

  if (!('IntersectionObserver' in window)) {
    // Kein Observer: alles direkt sichtbar machen statt es zu verstecken.
    root.classList.remove('tw-js');
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('tw-in');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  function scan(scope) {
    (scope || document).querySelectorAll('.tw-reveal:not(.tw-in)').forEach(function (el) {
      io.observe(el);
    });
  }

  scan();

  // Theme-Editor: Sections werden neu gerendert, dann erneut scannen.
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
